import { Result } from 'antd';
import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';
import GroupIdSelector from '../../../GroupIdSelector';
import { getIssueListData } from "../../../../api's/DataProcessorApi";
import LoadingIcon from '../../../../reusable-component/LoadingIcon';
import { mockIssueList } from './MockIssueList';
import ResolveModal from './ResolveModal';

function Issues({ nodeId }) {
  const { enqueueSnackbar } = useSnackbar();
  const [openResolveModal, setOpenResolveModal] = useState(false);
  const [groupId, setGroupId] = useState([]);
  const [selectedRows, setSelectedRows] = useState();
  const [issueListData, setIssueListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchIssueListData = async () => {
    try {
      setLoading(true);
      const payload = {
        nodeId,
        issueListType: 'Dedupe',
      };
      const response = await getIssueListData(payload);
      if (response.status === 200) {
        setIssueListData(response.data || []);
      } else {
        setIssueListData([]);
      }
      // setIssueListData(mockIssueList);
    } catch (error) {
      setIssueListData([]);
      enqueueSnackbar('Error while fetching issue list!', {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIssueListData();
  }, []);

  const firstRow = issueListData[0] || {};

  let columns = Object.keys(firstRow).map((key) => ({
    field: key,
    headerName: key.replace(/_/g, ' ').toUpperCase(),
  }));

  columns = [
    {
      field: 'group_id',
      headerName: 'GROUP ID',
    },
    ...columns.filter((column) => column.field !== 'group_id' && column.field !== 'failed_rule_json'),
  ];

  function handleRowClick(params) {
    console.log({ params });
    setGroupId(`${params.row.group_id}`);
    setSelectedRows(params.row);
  }

  const handleOpenResolveModal = () => {
    setOpenResolveModal(!openResolveModal);
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      {issueListData.length > 0 ? (
        <div
          style={{
            padding: '16px',
          }}
        >
          <DataGrid
            rows={issueListData}
            columns={columns}
            {...(issueListData.some((row) => row.group_id) && { getRowId: (row) => row.group_id })}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 7 },
              },
            }}
            pageSizeOptions={[5, 10]}
            onRowClick={handleRowClick}
          />

          <Button
            variant="contained"
            sx={{
              backgroundColor: '#00043C',
              '&:hover': { backgroundColor: '#00043C' },
              marginTop: '22px',
            }}
            onClick={handleOpenResolveModal}
            disabled={`${groupId}` === ''}
          >
            Resolve
          </Button>
        </div>
      ) : (
        <Result status="404" title="404" subTitle="No issue found !" />
      )}

      {openResolveModal && (
        <ResolveModal
          open={openResolveModal}
          onClose={handleOpenResolveModal}
          onSubmit={() => {}}
          groupId={groupId}
          nodeId={nodeId}
        />
      )}

      {loading && <LoadingIcon />}
    </div>
  );
}

export default Issues;
